import React from 'react';

import styles from './About.module.css';

var bristol = "https://www.bristol.ac.uk/study/undergraduate/2023/computer-science/bsc-comp-sci/";
var edinburgh = "https://www.ed.ac.uk/studying/postgraduate/degrees?id=107&r=site/view";
var haskell = "https://www.bris.ac.uk/unit-programme-catalogue/UnitDetails.jsa?unitCode=COMS10016";
var softtools = "https://www.bris.ac.uk/unit-programme-catalogue/UnitDetails.jsa?unitCode=COMS10012";
var css = "https://cssbristol.co.uk/about/";
var tradedesk = "https://www.thetradedesk.com/us";


class About extends React.Component {

    render() {
        return (
            <main className={styles.info}>
                <span className={styles.skills}><h2>Research Interests: </h2><p>Speech & Language Technology for Low-resource Languages; Social Recommendation Systems</p></span>
                <br /><br />
                <span className={styles.skills}><h2>Software Development Interests: </h2><p>Recommender Systems; Speech and Language Processing; Machine Learning Data Pipelines</p></span>

                <h2>About Me</h2>
                <div className={styles.descr}>
                    <p>I am an aspiring ML Research Scientist. Currently, I am a Software Engineer at The Trade Desk, working on big data driven insights for user interfaces, LLM agent tooling, and machine learning applications..</p>
                    <br></br>
                    <br></br>
                    <p>I recently graduated (with Distinction), with an MSc in Artificial Intelligence, from the University of Edinburgh where I studied as a Google DeepMind scholar. During my time in Edinburgh, I majored in Speech 
                        and Language Processing, and minored in Data Science. My research focused on multilingual speech and language technologies for low resource languages.
                    </p>
                        <br></br><br></br>
                        <p>Prior to my masters degree, I graduated from the University of Bristol with a degree in Computer Science (BSc) with First Class Honours.</p>
                        <br /><br />
                        <p>During my time at university, I did two summer internships at Amazon Prime Video (2023) and The Trade Desk (2024); both internships focused on Big Data processing.</p>
                    <br /><br />
                </div>
            </main>
        )
    }
}

export default About;